import React from 'react';
import { CheckSquare, Square } from 'lucide-react';

interface EcnPermissionToggleProps {
    checked: boolean;
    onChange: () => void;
    title: string;
    description: string;
    colorClass: 'green' | 'blue';
}

export const EcnPermissionToggle: React.FC<EcnPermissionToggleProps> = ({
    checked,
    onChange,
    title,
    description,
    colorClass
}) => {
    const bgColor = colorClass === 'green'
        ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800'
        : 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800';

    const iconColor = colorClass === 'green'
        ? 'text-green-600 dark:text-green-400'
        : 'text-blue-600 dark:text-blue-400';

    return (
        <div
            onClick={onChange}
            className={`flex items-start gap-3 p-4 rounded-lg cursor-pointer border transition-colors ${checked
                ? bgColor
                : 'bg-background hover:bg-gray-50 dark:hover:bg-gray-800 border-border'
                }`}
        >
            {checked ? (
                <CheckSquare className={`${iconColor} flex-shrink-0`} size={20} />
            ) : (
                <Square className="text-text-secondary/50 flex-shrink-0" size={20} />
            )}
            <div className="flex-1">
                <div className="font-medium text-text-primary">
                    {title}
                </div>
                <p className="text-sm text-text-secondary mt-1">
                    {description}
                </p>
            </div>
        </div>
    );
};
